<template>
  <div>
    <div v-show="currentPage === 1">
      <div class="retire-calculator">
        <div class="row">
          <div class="col-lg-12">
            <div class="card retire-border">
              <div class="card-body">
                <v-form @submit.prevent="submitForm">
                  <div class="row">
                    <div class="d-flex justify-content-between">
                      <div>
                        <p class="fs-2 fw-bold">Basic Details</p>
                      </div>
                      <div class="step-indicator-container">
                        <span class="step-button"
                          >Steps {{ currentPage }}/{{ steps.length }}</span
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="retire-input">
                        <label for="monthly-expenses" class="label-spacing"
                          >Current monthly expenses</label
                        >
                        <span class="retire-group">
                          <div class="rupees-symbol">₹</div>
                          <input
                            type="text"
                            class="form-control"
                            v-model="formData.currentMonthlyExpenses"
                            outlined
                            id="monthly-expenses"
                          />
                        </span>
                      </div>
                      <div class="retire-input">
                        <label for="current-age" class="label-spacing"
                          >Current age</label
                        >
                        <span class="retire-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="formData.currentAge"
                            outlined
                            id="current-age"
                          />
                        </span>
                        <p class="validate-msg">{{ ageMsg }}</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="retire-input">
                        <label for="retirement-age" class="label-spacing"
                          >Retirement age</label
                        >
                        <span id="age-req" class="retire-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="formData.retirementAge"
                            outlined
                            id="retirement-age"
                          />
                        </span>
                      </div>
                      <div class="retire-input">
                        <label for="expected-life-span" class="label-spacing"
                          >Expected life span</label
                        >
                        <span class="retire-group">
                          <button type="button" @click="decreaseLifeSpan">
                            -
                          </button>
                          <input
                            type="text"
                            class="form-control text-center"
                            v-model="formData.expectedLifeSpan"
                            outlined
                            id="expected-life-span"
                          />
                          <button type="button" @click="increaseLifeSpan">
                            +
                          </button>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-6">
                      <button
                        type="button"
                        @click="checkReq()"
                        class="retire-button"
                      >
                        Next
                      </button>
                    </div>
                    <p>{{ message }}</p>
                  </div>
                </v-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="currentPage === 2">
      <div class="retire-calculator">
        <div class="row">
          <div class="col-lg-12">
            <div class="card retire-border">
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div>
                    <p class="desktop-br fs-2 fw-bold">Investment Details</p>
                    <p class="mobile-br fs-2 fw-bold">Investment<br />Details</p>
                  </div>
                  <div class="step-indicator-container">
                    <span class="step-button"
                      >Steps {{ currentPage }}/{{ steps.length }}</span
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="retire-input">
                      <label for="existing-investments" class="label-spacing"
                        >Current value of existing investments</label
                      >
                      <span id="invest-req" class="retire-group">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="formData.existingInvestements"
                          outlined
                          id="existing-investments"
                        />
                      </span>
                      <p class="validate-msg">{{ msg }}</p>
                    </div>
                    <div class="retire-input">
                      <label for="expected-inflation" class="label-spacing"
                        >Expected inflation</label
                      >
                      <span class="retire-group">
                        <button type="button" @click="decreaseInflation">
                          -
                        </button>
                        <input
                          type="text"
                          class="form-control text-center"
                          v-model="formData.expectedInflation"
                          outlined
                          id="expected-inflation"
                        />
                        <button type="button" @click="increaseInflation">
                          +
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="retire-input">
                      <label for="post-retire" class="label-spacing"
                        >Post-retirement investment return</label
                      >
                      <span class="retire-group">
                        <button type="button" @click="decreasePostRetire">
                          -
                        </button>
                        <input
                          type="text"
                          class="form-control text-center"
                          v-model="formData.postRetireMentInvestment"
                          outlined
                          id="post-retire"
                        />
                        <button type="button" @click="increasePostRetire">
                          +
                        </button>
                      </span>
                    </div>
                    <div class="retire-input">
                      <label for="pre-retire" class="label-spacing"
                        >Pre-retirement investment return</label
                      >
                      <span class="retire-group">
                        <button type="button" @click="decreasePreRetire">
                          -
                        </button>
                        <input
                          type="text"
                          class="form-control text-center"
                          v-model="formData.preRetireMentInvestment"
                          outlined
                          id="pre-retire"
                        />
                        <button type="button" @click="increasePreRetire">
                          +
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <button
                      type="button"
                      @click="currentPage--"
                      class="retire-previous"
                    >
                      Previous
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="button"
                      @click="submitForm()"
                      class="retire-button"
                    >
                      Calculate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="currentPage === 3">
      <div class="retire-calculator">
        <div class="row">
          <div class="col-lg-12">
            <div class="card retire-border">
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <div><p class="fs-2 fw-bold">Results</p></div>
                  <div class="step-indicator-container">
                    <span class="step-button"
                      >Steps {{ currentPage }}/{{ steps.length }}</span
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="retire-input">
                      <label for="retire-expense" class="label-spacing"
                        >Monthly expense at the time of retirement</label
                      >
                      <span class="retire-group" style="background: #f2f2f2">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="monthlyExpenseAtRetirement"
                          outlined
                          :disabled="true"
                          id="retire-expense"
                        />
                      </span>
                    </div>
                    <div class="retire-input">
                      <label for="current-investment" class="label-spacing"
                        >Future value of current investments</label
                      >
                      <span class="retire-group" style="background: #f2f2f2">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="this.currentInvestment"
                          outlined
                          :disabled="true"
                          id="current-investment"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="retire-input">
                      <label for="total-corpus" class="label-spacing"
                        >Corpus Required for ({{ periodIncome }} years) Post
                        Retirement</label
                      >
                      <span class="retire-group" style="background: #f2f2f2">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="totalCorpus"
                          outlined
                          :disabled="true"
                          id="total-corpus"
                        />
                      </span>
                    </div>
                    <div class="retire-input">
                      <label for="corpus_value" class="label-spacing"
                        >Corpus to be built in ({{ periodSaving }} years)</label
                      >
                      <span class="retire-group" style="background: #f2f2f2">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="corpusValue"
                          outlined
                          :disabled="true"
                          id="corpus_value"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="retire-input">
                      <label for="monthly-investment" class="label-spacing"
                        >Monthly investment needed</label
                      >
                      <span
                        class="retire-group"
                        :class="
                          finalInvest < 0
                            ? 'card-body negativeResult'
                            : 'card-body positiveresult'
                        "
                      >
                        <input
                          type="text"
                          class="form-control"
                          v-model="monthlyInvestment"
                          outlined
                          :disabled="true"
                          id="monthly-investment"
                        />
                      </span>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <button
                          type="button"
                          @click="currentPage--"
                          class="retire-previous"
                        >
                          Previous
                        </button>
                      </div>
                      <div class="col-6">
                        <button
                          type="button"
                          @click="goToPage(1)"
                          class="retire-button"
                        >
                          Start Over
                        </button>
                      </div>
                    </div>
                    <i class="retire-disclaim"
                      >Disclaimer: Results shown for illustrative purpose only
                      and should not be construed as investment advice</i
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RetirementCalculator",
  components: {},
  data() {
    return {
      formData: {
        currentMonthlyExpenses: 50000,
        postRetireMentInvestment: "7.5 %",
        preRetireMentInvestment: "12 %",
        expectedInflation: "4.5 %",
        currentAge: 25,
        retirementAge: "",
        expectedLifeSpan: 75,
        existingInvestements: "",
        minValue: 0,
        maxValue: 100,
      },
      currentPage: 1,
      steps: ["Basic Details", "Investment Details", "Results"],
      periodIncome: "",
      monthlyExpenseAtRetirement: "",
      totalCorpus: "",
      currentInvestment: "",
      corpusValue: "",
      buildCorpus: "",
      monthlyInvestment: "",
      timePeriod: "",
      formSubmitted: false,
      ageMsg: "",
      msg: "",
      finalInvest: "",
      message: "",
      periodSaving: "",
    };
  },
  watch: {
    "formData.retirementAge": function (newCost) {
      if (newCost) {
        document.getElementById("age-req").style.borderColor = "";
        this.ageMsg = "";
      }
    },
    "formData.existingInvestements": function (newCost) {
      if (newCost) {
        document.getElementById("invest-req").style.borderColor = "";
        this.msg = "";
      }
    },
  },
  methods: {
    checkReq() {
      this.formSubmitted = true;
      if (!this.formData.retirementAge && this.currentPage == 1) {
        document.getElementById("age-req").style.borderColor = "red";
        this.ageMsg = "This field is required";
        return;
      }
      if (
        this.currentPage == 1 &&
        Number(this.formData.retirementAge) <= Number(this.formData.currentAge)
      ) {
        document.getElementById("age-req").style.borderColor = "red";
        this.ageMsg = "Current age can't be greater than retirement age";
        return;
      }
      this.currentPage++;
    },
    submitForm() {
      if (!this.formData.existingInvestements && this.currentPage == 2) {
        document.getElementById("invest-req").style.borderColor = "red";
        this.msg = "This field is required";
        return;
      }
      this.currentPage++;
      this.calculateTotalValue();
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
      this.message = "Thanks for using PrimeInvestor's retirement calculator!";
      this.formData.retirementAge = "";
      this.formData.existingInvestements = "";
    },
    increaseLifeSpan() {
      if (this.formData.expectedLifeSpan < 75) {
        this.formData.expectedLifeSpan = 75;
      } else if (this.formData.expectedLifeSpan < 100) {
        this.formData.expectedLifeSpan = Math.min(
          this.formData.expectedLifeSpan + 5,
          100
        );
      }
    },
    decreaseLifeSpan() {
      if (this.formData.expectedLifeSpan <= 75) {
        this.formData.expectedLifeSpan = 75;
      } else if (this.formData.expectedLifeSpan <= 100) {
        this.formData.expectedLifeSpan = Math.max(
          this.formData.expectedLifeSpan - 5,
          75
        );
      }
    },
    increasePostRetire() {
      const numericValue = parseFloat(this.formData.postRetireMentInvestment);
      if (numericValue < 4.5) {
        this.formData.postRetireMentInvestment = `${Math.min(
          numericValue + 0.5,
          4.5
        )} %`;
      } else if (numericValue < 15.5) {
        this.formData.postRetireMentInvestment = `${numericValue + 0.5} %`;
      }
    },
    decreasePostRetire() {
      const numericValue = parseFloat(this.formData.postRetireMentInvestment);
      if (numericValue <= 4.5) {
        if (numericValue > 15.5) {
          this.formData.postRetireMentInvestment = `${Math.max(
            numericValue - 0.5,
            4.5
          )} %`;
        }
      } else {
        this.formData.postRetireMentInvestment = `${numericValue - 0.5} %`;
      }
    },
    increasePreRetire() {
      const numericValue = parseFloat(this.formData.preRetireMentInvestment);
      if (numericValue < 6.5) {
        this.formData.preRetireMentInvestment = `${Math.min(
          numericValue + 0.5,
          6.5
        )} %`;
      } else if (numericValue < 15.5) {
        this.formData.preRetireMentInvestment = `${numericValue + 0.5} %`;
      }
    },
    decreasePreRetire() {
      const numericValue = parseFloat(this.formData.preRetireMentInvestment);
      if (numericValue <= 6.5) {
        if (numericValue > 15.5) {
          this.formData.preRetireMentInvestment = `${Math.max(
            numericValue - 0.5,
            6.5
          )} %`;
        }
      } else {
        this.formData.preRetireMentInvestment = `${numericValue - 0.5} %`;
      }
    },
    increaseInflation() {
      const numericValue = parseFloat(this.formData.expectedInflation);
      if (numericValue < 5.5) {
        this.formData.expectedInflation = `${Math.min(
          numericValue + 0.5,
          5.5
        )} %`;
      } else if (numericValue < 10) {
        this.formData.expectedInflation = `${numericValue + 0.5} %`;
      }
    },
    decreaseInflation() {
      const numericValue = parseFloat(this.formData.expectedInflation);
      if (numericValue <= 5.5) {
        if (numericValue > 4) {
          this.formData.expectedInflation = `${Math.max(
            numericValue - 0.5,
            4
          )} %`;
        }
      } else {
        this.formData.expectedInflation = `${numericValue - 0.5} %`;
      }
    },
    calculateTotalValue() {
      const monthly = this.formData.currentMonthlyExpenses;
      const inflation = parseFloat(this.formData.expectedInflation);
      const retireAge = this.formData.retirementAge;
      const currentAge = this.formData.currentAge;
      const lifeSpan = this.formData.expectedLifeSpan;
      const monthlyExpenseAtRetire = Math.round(
        monthly * Math.pow(1 + inflation / 100, retireAge - currentAge)
      );
      this.monthlyExpenseAtRetirement =
        monthlyExpenseAtRetire.toLocaleString("en-IN");
      const difference = this.formData.expectedLifeSpan - retireAge;
      this.periodIncome = difference;
      this.periodSaving = retireAge - currentAge;
      const totalCorpusValue = Math.round(
        ((monthlyExpenseAtRetire *
          (1 +
            ((Math.pow(
              1 +
                ((Math.pow(
                  1 +
                    (([parseFloat(this.formData.postRetireMentInvestment)] /
                      100) *
                      3) /
                      12,
                  4
                ) -
                  1) *
                  100) /
                  100,
              1 / 12
            ) -
              1) *
              100) /
              100)) /
          (((Math.pow(
            1 +
              ((Math.pow(
                1 +
                  (([parseFloat(this.formData.postRetireMentInvestment)] /
                    100) *
                    3) /
                    12,
                4
              ) -
                1) *
                100) /
                100,
            1 / 12
          ) -
            1) *
            100) /
            100 -
            ((Math.pow(1 + [inflation] / 100, 1 / 12) - 1) * 100) / 100)) *
          (1 -
            Math.pow(
              (1 +
                ((Math.pow(1 + [inflation] / 100, 1 / 12) - 1) * 100) / 100) /
                (1 +
                  ((Math.pow(
                    1 +
                      ((Math.pow(
                        1 +
                          (([
                            parseFloat(this.formData.postRetireMentInvestment),
                          ] /
                            100) *
                            3) /
                            12,
                        4
                      ) -
                        1) *
                        100) /
                        100,
                    1 / 12
                  ) -
                    1) *
                    100) /
                    100),
              ([lifeSpan] - [retireAge]) * 12
            ))
      );
      this.totalCorpus = totalCorpusValue.toLocaleString("en-IN");
      const currentInvest = Math.round(
        this.formData.existingInvestements *
          Math.pow(
            1 + parseFloat(this.formData.preRetireMentInvestment) / 100,
            retireAge - currentAge
          )
      );
      this.currentInvestment = currentInvest.toLocaleString("en-IN");
      const corpusValue = Math.round(totalCorpusValue - currentInvest);
      this.corpusValue = corpusValue.toLocaleString("en-IN");
      this.buildCorpus = retireAge - currentAge;
      const monthInvest = Math.round(
        ((totalCorpusValue - currentInvest) *
          (parseFloat(this.formData.preRetireMentInvestment) / 100)) /
          12 /
          (Math.pow(
            1 + parseFloat(this.formData.preRetireMentInvestment) / 100 / 12,
            this.buildCorpus * 12
          ) -
            1)
      );
      this.finalInvest = monthInvest;
      this.monthlyInvestment = `₹ ${monthInvest.toLocaleString("en-IN")}`;
    },
    increaseTimePeriod() {
      if (this.formData.time < 50) {
        this.formData.time++;
      }
    },
    decreaseTimePeriod() {
      if (this.formData.time > 1) {
        this.formData.time--;
      }
    },
  },
};
</script>

<style scoped>
.step-indicator-container {
  margin-top: 10px;
}

@media all and (max-width: 406px) {
  .desktop-br {
    display: none;
  }
  .mobile-br {
    display: inline;
  }
}
@media all and (min-width: 406px) {
  .desktop-br {
    display: inline;
  }
  .mobile-br {
    display: none;
  }
}

.step-button {
  padding: 10px 20px;
  border-radius: 5px;
  background-color: #f2f2f2;
  color: #012e40 !important;
}

.retire-calculator .retire-input label {
  display: block;
  font-weight: bold;
  font-size: 16px;
  color: #012e40 !important;
}

.retire-input input {
  text-align: justify;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.retire-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
}

.retire-button {
  width: 100%;
  background: #00a3d9;
  color: white;
  padding: 0.6em;
  margin: 0px 0 12px;
  border-radius: 5px;
}

.retire-previous {
  width: 100%;
  color: #012e40 !important;
  border: 1px solid #012e40;
  padding: 0.6em;
  margin: 0px 0 12px;
  border-radius: 5px;
  background: transparent;
}

.retire-calculator .retire-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.label-spacing {
  margin-bottom: 0.7rem;
}

.retire-border {
  border: none;
  outline: none;
  background: none;
}

.retire-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;
}

.validate-msg {
  color: #dd2e44;
  margin-top: 4px;
  font-size: 12px;
}

.retire-input {
  position: relative;
}

.positiveresult {
  background: rgba(56, 226, 178, 0.2);
  border-radius: 10px;
}

.positiveresult input {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #012e40;
  text-shadow: 3px 3px 8px rgba(0, 255, 87, 0.25);
  border: none;
  background: none;
}
.negativeResult {
  background: rgba(226, 56, 56, 0.2);
  border-radius: 10px;
}

.negativeResult input {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #dd2e44;
  text-shadow: 3px 3px 8px rgba(255, 0, 0, 0.25);
  border: none;
  background: none;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
  margin: 5px;
}

.retire-disclaim {
  color: #918d99;
  font-size: 14px;
  margin-top: 9%;
}
</style>
